import defaultImage from '@/assets/img/svg/default-image.svg';

export default {
  name: 'ImageCard',
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    isContain: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultImage
    };
  },
  computed: {},
  created() {},
  methods: {}
};
